import PropTypes from 'prop-types';
import OwlCarousel from 'react-owl-carousel';
// import Slider   from 'react-slick';
// import SliderArrow from '~/js/components/SliderArrow';

const internals = {
  sliderOptions: {
    touchDrag: true,
    mouseDrag: true,
    lazyLoad: true,
    items: 1,
    loop: true,
    nav: true,
    navText: ["<i class='icon-button-prev'></i>", "<i class='icon-button-next'></i>"]
  }
};

const ToursItem = (props) => {
  const {
    eventId,
    groupId,
    rstCode,
    tourImages,
    eventName,
    rates,
    description,
    resortName
  } = props;
  const { sliderOptions } = internals;
  const div = document.createElement('div');
  const detailsURL = `/tours/details/?eventID=${eventId}&groupID=${groupId}&rstCode=${rstCode}&resortName=${resortName}`;

  let images;
  let text;

  div.innerHTML = description;
  text = div.textContent || div.innerText || '';
  if(text.length > 180) {
    text = text.substring(0, 180) + '...';
  }

  if(tourImages.hasOwnProperty('medium') && tourImages.medium.length > 0) {
    if (tourImages.medium.length === 1) {
      images = (
        <div className="equal-heights">
          <img src={tourImages.medium[0]} alt="" />
        </div>
      );
    }else{
      images = (
        <OwlCarousel {...sliderOptions} dots={false}>
          {tourImages.medium.map((image, index)=>{
            return (
              <div className="slider-item" key={index}>
                <div className="equal-heights">
                  <img
                    src={image}
                    data-lazy={image}
                    alt="" />
                </div>
              </div>
            );
          })}
        </OwlCarousel>
      );
    }
  }else{
    images = (
      <div className="equal-heights">
        <div className="comingSoon">
          <i className="icon-camera" />
          <div className="caption">image coming soon</div>
        </div>
      </div>
    );
  }

  function createIBMTag() {
    console.log('ssd');
    window.cmCreateProductviewTag(
      resortName + ' : ' + eventName,
      resortName + ' : ' + eventName,
      resortName + ' : ' + 'Tours'
    );

    return true;
  }

  return (
    <div className="event xs-12 lg-6 xl-4">
      <div className="panel">
        <div className="event-slider">
          {images}
        </div>
        <div className="event-caption">
          <span>{eventName}</span>
        </div>

        <div className="event-rates">
          {rates.map((element, index)=>{
            return (
              <div className="rate" key={index}>
                <span className="value">${element.rate || 0}</span>
                <span className="type">{element.eventRateType || ''}<span>(USD)</span></span>
              </div>
            );
          })}
        </div>

        <div className="event-description">
          <p>{text}</p>
        </div>

        <div className="buttons">
          <a
            onClick={() => {createIBMTag();}}
            className="details-btn"
            href={detailsURL}>View Details <i className="icon-button-next" />
          </a>
        </div>
      </div>
    </div>
  );
};

ToursItem.propTypes = {
  eventId: PropTypes.number,
  rstCode: PropTypes.string,
  tourImages: PropTypes.object,
  eventName: PropTypes.string,
  rates: PropTypes.array,
  description: PropTypes.string,
  resortName: PropTypes.string
};

ToursItem.defaultProps = {
  eventId: 0,
  rstCode: '',
  tourImages: {},
  eventName: '',
  rates: [],
  description: '',
  resortName: ''
};

export default ToursItem;
